import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedDish from './components/FeaturedDish';
import MenuSection from './components/MenuSection';
import Reviews from './components/Reviews';
import Visit from './components/Visit';
import Footer from './components/Footer';
import PreorderPage from './pages/PreorderPage';
import StaffPage from './pages/StaffPage';
import { CartProvider } from './context/CartContext';

const Home = () => (
  <div className="min-h-screen bg-[#f4ead4] font-sans">
    <Navbar />
    <Hero />
    <FeaturedDish />
    <MenuSection />
    <Reviews />
    <Visit />
    <Footer />
  </div>
);

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/preorder" element={<PreorderPage />} />
          <Route path="/staff" element={<StaffPage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
